'use client';
import { createContext } from 'react';

import type { DiSymbolMapType } from '../../../../di/entry.js';

export type CouponStoreApi = ReturnType<DiSymbolMapType['ICouponZustandStoreService']['bootstrap']>;
export type CouponStore = ReturnType<CouponStoreApi['getState']>;

export const CouponStoreContext = createContext<CouponStoreApi | undefined>(undefined);
